import React from 'react';

import { StorageEnforcementFlags } from './flags/StorageEnforcementFlagsLazy.tsx';
import { GracePeriodModal } from './modals/GracePeriodModal/GracePeriodModalLazy.tsx';
import { BlockCreateModal } from './modals/BlockCreateModal/BlockCreateModalLazy.tsx';

export const StorageEnforcement = () => {
	return (
		<>
			<StorageEnforcementFlags />
			<GracePeriodModal />
			<BlockCreateModal />
		</>
	);
};
